<template>
  <b-container class="pb-0" style="padding: 0%;">
    <b-form-group label="Amount" label-for="amount" class="mb-0">
      <div class="input-group">
        <b-row class="input-group-prepend px-0" id="currency_parent">
          <b-col
            cols="12"
            :sm="size.currency_sm"
            class="pr-0"
            id="currency_select"
          >
            <v-autocomplete
              v-on:change="currencyAutoMove"
              id="currency"
              v-model="localValue.currency"
              name="currency"
              :items="currencies"
              :filter="autoCompleteStringFilter"
              item-text="text"
              item-value="value"
              autocomplete="currency"
              outlined
              dense
              :disabled="currency_amount_readOnly"
            ></v-autocomplete>
          </b-col>
          <b-col
            cols="12"
            :sm="size.currencyAmount_sm"
            class="pl-0"
            id="currency_input"
          >
            <b-form-input
              ref="currencyAmount"
              id="amount"
              v-model="localValue.amount"
              type="text"
              :state="state('amount')"
              aria-describedby="amount-error"
              :readonly="currency_amount_readOnly"
            />
          </b-col>
        </b-row>
      </div>
    </b-form-group>
  </b-container>
</template>

<script>
import AutoNumeric from "autonumeric";
import { autoCompleteStringFilter } from "@/services/Formatting.js";
import CurrencyMixin from "@/components/payment/CurrencyMixin.js";

export default {
  mixins: [CurrencyMixin],
  props: {
    size: {
      type: Object,
      default() {
        return {
          currency_sm: 4,
          currencyAmount_sm: 5
        };
      }
    },
    currencies: {
      type: Array
    },
    currency_amount_readOnly: {
      type: Boolean,
      default: false
    },
    value: {
      amount: {
        type: Number,
        default: 0
      },
      currency: {
        type: String
      }
    },
    autoNumericOptions: null,
    errorMessages: {
      type: Object,
      required: false,
      default() {
        return {
          amount: null,
          currency: null
        };
      }
    }
  },
  data() {
    return {
      autoNumericElement: {}
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set() {}
    },
    errors() {
      return {
        amount: this.getErrorMessage("amount"),
        currency: this.getErrorMessage("currency")
      };
    },
    AutoNumericOptions() {
      if (this.autoNumericOptions != null) return this.autoNumericOptions;
      return {};
    }
  },
  methods: {
    autoCompleteStringFilter(item, searchText, itemText) {
      return autoCompleteStringFilter(item, searchText, itemText);
    },
    currencyAutoMove() {
      this.$refs.currencyAmount.focus();
    },
    getErrorMessage(name) {
      return !!this.errorMessages ? this.errorMessages[name] : null;
    },
    state(name) {
      return this.errors[name] == null ? null : !this.errors[name].length;
    },
    setAutoNumericElementValue(val) {
      if (this.autoNumericElement === null) return;

      this.autoNumericElement.set(val);
    },
    setAutoNumericOptions(options) {
      if (this.autoNumericElement === null) return;

      this.autoNumericElement.update(options);
    }
  },
  async mounted() {
    this.localValue.currency = this.localValue.currency
      ? this.localValue.currency
      : this.defaultCurrencyCode;
    this.autoNumericElement = AutoNumeric.getAutoNumericElement(
      document.getElementById("amount")
    );
    if (this.autoNumericElement === null) {
      this.autoNumericElement = new AutoNumeric("#amount", {
        ...this.AutoNumericOptions,
        ...{
          digitGroupSeparator: ",",
          decimalCharacter: "."
        }
      });
    }

    this.autoNumericElement.set(this.value.amount);
  }
};
</script>

<style lang="scss" scoped>
label {
  font-weight: 500;
}
.input-group-prepend {
  padding-right: 1rem !important;
}
</style>
